<template>
  <v-dialog v-model="mostrar" max-width="800px" persistent>
    <form>
      <v-card>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>Editar Item</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-select
            v-if="tipo == 'PARECER' || tipo == 'PARECER-RECURSO'"
            :items="situacoesParecer"
            label="Situação"
            v-model="rascunho.situacao"
            item-text="label"
            item-value="value"
            required
          ></v-select>
          <v-dialog
            v-if="rascunho.situacao == 'DESFAVORAVEL' && tipo == 'PARECER'"
            ref="dialogDtRecurso"
            v-model="modalDataRecurso"
            :return-value.sync="rascunho.dataLimiteRecurso"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="rascunho.dataLimiteRecurso | formatDate"
                @input="rascunho.dataLimiteRecurso = $event.target.valueAsDate"
                label="Data limite para Recurso"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                required
              ></v-text-field>
            </template>
            <v-date-picker
              locale="pt-BR"
              v-model="rascunho.dataLimiteRecurso"
              @input="$refs.dialogDtRecurso.save(rascunho.dataLimiteRecurso)"
            >
            </v-date-picker>
          </v-dialog>
          <div v-if="rascunho.situacao == 'DESFAVORAVEL' && tipo == 'PARECER'">
              <span><strong class="red--text">Atenção:</strong> A data limite para protocolo de recurso é de 02 (dois) dias úteis contabilizados a partir do primeiro dia útil posterior à data de emissão do parecer desfavorável. 
Sábados, domingos, feriados e pontos facultativos não são considerados dias úteis para fins de definição de prazo para protocolo de recurso</span>
            </div>
          <v-textarea
            background-color="grey lighten-3"
            v-model="rascunho.texto"
            label="Parecer"
            required
            counter
            maxlength="8000"
          ></v-textarea>
        </v-card-text>

        <lista-de-upload-de-arquivos
          ref="lista"
          :item="rascunho"
        ></lista-de-upload-de-arquivos>

        <v-card-actions>
          <v-container>
            <v-row>
              <v-col xs="12">
                <v-btn block color="warning" @click="cancelarInclusaoParecer">
                  Fechar
                </v-btn>
              </v-col>
              <v-col>
                <v-btn block color="green darken-2" dark @click="$refs.fileInput.click()">
                  <input
                    style="display: none"
                    type="file"
                    ref="fileInput"
                    multiple
                    @change="addFile"
                  />
                  Anexar
                </v-btn>
              </v-col>
              <v-col>
                <v-btn block color="secondary" @click="salvarRascunho">
                  Salvar Rascunho
                </v-btn>
              </v-col>
              <v-col>
                <v-btn block color="primary" @click="exibirConfirmacaoSalvarParecer">
                  Finalizar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>          
        </v-card-actions>
      </v-card>
    </form>
    <dialogo-confirmacao
      texto="Após esta ação não será mais possível alterar os dados"
      :visivel="mostrarConfirmacaoParecer"
      @confirmar="finalizarParecer"
      @cancelar="cancelarConfirmacaoParecer"
    ></dialogo-confirmacao>
  </v-dialog>
</template>

<script>
import DialogoConfirmacao from "./DialogoConfirmacao.vue";
import * as PreMatriculaService from "@/services/prematricula.service";
import ListaDeUploadDeArquivos from "./ListaDeUploadDeArquivos.vue";
import moment from 'moment';

export default {
  components: { DialogoConfirmacao, ListaDeUploadDeArquivos },
  props: {
    rascunho: {
      type: Object,
      required: true,
    },
    mostrar: {
      type: Boolean,
      default: false,
    },
    tipo: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      modalDataRecurso: false,
      dlgParecer: false,
      mostrarConfirmacaoParecer: false,
      situacoesParecer: [
        { label: "Favorável", value: "FAVORAVEL" },
        { label: "Desfavorável", value: "DESFAVORAVEL" },
      ],
    };
  },
  methods: {
    addAnexoParecer(event) {
      var arquivo = event.target.files[0];
      this.parecer.anexos.push(arquivo);
      this.$refs.fileInput.value = "";
    },
    removeAnexoParecer(anexo) {
      this.parecer.anexos.splice(this.parecer.anexos.indexOf(anexo), 1);
    },
    cancelarConfirmacaoParecer() {
      this.mostrarConfirmacaoParecer = false;
    },
    exibirConfirmacaoSalvarParecer() {
      this.mostrarConfirmacaoParecer = true;
    },
    cancelarInclusaoParecer() {
      this.$emit("cancelar");
    },
    salvarRascunho() {
      this.$nprogress.start();
      PreMatriculaService.salvarRascunho(this.rascunho)
        .then(() => {
          this.$msg.success("Rascunho Salvo");
          this.$emit("salvou");
        })
        .finally(() => {
          this.mostrarConfirmacaoParecer = false;
          this.$nprogress.done();
        });
    },
    finalizarParecer() {
      if (this.rascunho.situacao == 'DESFAVORAVEL' && this.tipo == 'PARECER'){
        if (this.rascunho.dataLimiteRecurso == null || this.rascunho.dataLimiteRecurso.length == 0){
          this.$msg.error("Informe a data limite para recurso");
          this.cancelarConfirmacaoParecer();
          return;
        }
        if (moment(this.rascunho.dataLimiteRecurso).isSameOrBefore(moment())){
          this.$msg.error("A Data limite deve ser posterior a data atual");
          this.cancelarConfirmacaoParecer();
          return;
        }
      }
      this.$nprogress.start();
      PreMatriculaService.finalizarParecer(this.rascunho)
        .then((res) => {
          this.$msg.success("Parecer Finalizado");
          this.$emit("finalizou", res.data);
        })
        .finally(() => {
          this.mostrarConfirmacaoParecer = false;
          this.$nprogress.done();
        });
    },
    addFile(event) {
      this.$refs.lista.addFile(event);
      this.$refs.fileInput.value = "";
    }
  },
};
</script>